import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Admin demo mode: while it is on, orders and deliveries show every fleet as a
 * plain "DSP" (the way merchants already see Motoclick), so the admin app can
 * be shown to someone without revealing which delivery partners we use.
 *
 * Kept in localStorage, so it is per browser and survives reloads and logins.
 */
type DemoModeState = {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
};

export const useDemoMode = create<DemoModeState>()(
  persist(
    (set) => ({
      enabled: false,
      setEnabled: (enabled) => set({ enabled }),
    }),
    { name: 'admin-demo-mode' }
  )
);

/** Whether fleets should be masked right now. */
export const isFleetHidden = () => useDemoMode.getState().enabled;
